module.exports = " <div data-abr-sticky data-stuck=true data-height=0 class=race-schedule-stuck-header :class=\"{ visible: visible }\"> <div class=\"race-schedule-header full\" :class=headerClass> <div class=row> <div class=\"small-12 columns\"> <h4>{{ headerText }}</h4> </div> </div> </div> <div class=\"row small-collapse medium-uncollapse\" v-if=date> <div class=\"small-12 medium-2 large-1 columns date end\"> <race-list-date-label :date=date></race-list-date-label> </div> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./site/sites/all/themes/custom/abr_theme/js/race-schedule/components/StuckHeader.vue
 ** module id = 459
 ** module chunks = 1
 **/